
import { useState } from "react";

import { 
    PlusIcon,
    PaymentCard,
    AddPaymentMethodPopUp
 } from "../../components";

const cardData = {
    cards: [
        {   
            iconUrl: `${process.env.PUBLIC_URL}/media/images/Mastercard.png`, 
            number: '**** **** **** 7892', 
            expiration: '02/2028', 
        },
        {   
            iconUrl: `${process.env.PUBLIC_URL}/media/images/visa.png`, 
            number: '**** **** **** 6789', 
            expiration: '02/2028', 
        },
        {   
            iconUrl: `${process.env.PUBLIC_URL}/media/images/Mastercard.png`, 
            number: '**** **** **** 9292', 
            expiration: '01/2026', 
        },
    ]
};

const PaymentMethods = () => {

    const [isPopupOpen, setPopupOpen] = useState(false);

    return (
        <>
            <div>
                <div className="pt-8">
                    <div className="flex items-center w-full pb-5">
                        <h2 className="text-base font-medium text-primary-0 font-redhat">Payment Methods</h2>
                        <div className="relative flex-grow ml-4 border-b border-gray-100 top-2"></div>
                    </div>
                    <div className="flex lg:items-center justify-between flex-col lg:flex-row">
                        <div>
                            <p className="text-base text-gray-700 font-redhat">Payment cards</p>
                            <p className="text-base text-gray-80 font-redhat">Add a payment method using our secure payment system</p>
                        </div>
                        <div className="pt-4 lg:pt-0 flex justify-center lg:block">
                            <button 
                            onClick={() => setPopupOpen(true)}
                            className='flex text-sm font-medium leading-4 text-gold-300 font-redhat'>
                                <PlusIcon className="text-gold-300 group-hover:text-gold-500" />
                                Add Payment Method
                            </button>
                        </div>
                    </div>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-2 pt-5 gap-y-6 gap-x-9">
                    <PaymentCard data={cardData}/>
                </div>
                <div className="pb-4 lg:pb-0 flex justify-center lg:block">
                    <button
                        onClick={() => setPopupOpen(true)}
                        className="flex items-center pt-8 text-sm font-medium leading-4 text-gold-300 font-redhat focus:outline-none"
                    >
                        <PlusIcon className="text-gold-300 group-hover:text-gold-500 mr-1" />
                        Add Payment Method
                    </button>
                </div>

            
            </div>
            {/* Render the popup */}
            <AddPaymentMethodPopUp isOpen={isPopupOpen} onClose={() => setPopupOpen(false)} />
         </>
    )
}

export default PaymentMethods;